import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaTimbresTimbreEstatusTimbrado', NominaTimbresTimbreEstatusTimbradoService)

function NominaTimbresTimbreEstatusTimbradoService($http) {
  this.put = _put

  function _put(id_nomina, id_proyecto, id_colaborador, indice, data) {
    return $http.put('/api/nominas/nomina/timbres/timbre/estatus/timbrado', data, {
      params: {
        id_nomina: id_nomina,
        id_proyecto: id_proyecto,
        id_colaborador: id_colaborador,
        indice: indice,
      },
      schema: NominaTimbresTimbreEstatusTimbradoSchema,
      clearCache: 'nominas',
    })
  }

  let NominaTimbresTimbreEstatusTimbradoSchema = {}
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Timbres/Timbre/Estatus/Timbrado.js